// @ts-nocheck
/* eslint-disable */
import { fl3UserIcon } from './3-user';
import { flTransferVerticalSquareIcon } from './Transfer-Vertical-Square';
import { flAddChannelIcon } from './add-channel';
import { flChannelIcon } from './channel';
import { flAllScopeIcon } from './all-scope';
import { flArrowLeftIcon } from './arrow-left';
import { flArrowRightIcon } from './arrow-right';
import { flArrowUpRightIcon } from './arrow-up-right';
import { flArrowsClockwiseIcon } from './arrows-clockwise';
import { flArticleIcon } from './article';
import { flBedIcon } from './bed';
import { flBellIcon } from './bell';
import { flBicycleIcon } from './bicycle';
import { flBookOpenIcon } from './book-open';
import { flBubblePlusIcon } from './bubble-plus';
import { flBuildingIcon } from './building';
import { flBuildingsIcon } from './buildings';
import { flCalendarBlankIcon } from './calendar-blank';
import { flCalendarPlusIcon } from './calendar-plus';
import { flCalendarSmallIcon } from './calendar-small';
import { flCalendarXIcon } from './calendar-x';
import { flCalendarIcon } from './calendar';
import { flCameraIcon } from './camera';
import { flCarIcon } from './car';
import { flCaretDownIcon } from './caret-down';
import { flChartBarHorizontalIcon } from './chart-bar-horizontal';
import { flChartBarSquareIcon } from './chart-bar-square';
import { flChatBubbleFavoriteOvalStarIcon } from './chat-bubble-favorite-oval-star';
import { flChatBubbleOvalCheckIcon } from './chat-bubble-oval-check';
import { flChatBubbleOvalDeleteIcon } from './chat-bubble-oval-delete';
import { flChatBubbleTextSquareIcon } from './chat-bubble-text-square';
import { flChatSendIcon } from './chat-send';
import { flChatIcon } from './chat';
import { flCheckSquareIcon } from './check-square';
import { flCheckIcon } from './check';
import { flChevronBackIcon } from './chevron-back';
import { flChevronDownIcon } from './chevron-down';
import { flChevronForwardIcon } from './chevron-forward';
import { flChevronUpIcon } from './chevron-up';
import { flCircleMarkIcon } from './circle-mark';
import { flCleaningIcon } from './cleaning';
import { flClockAfternoonIcon } from './clock-afternoon';
import { flClockCounterClockwiseIcon } from './clock-counter-clockwise';
import { flCloseIcon } from './close';
import { flCogIcon } from './cog';
import { flConferenceIcon } from './conference';
import { flConsumptionIcon } from './consumption';
import { flCookieIcon } from './cookie';
import { flCopyDocumentIcon } from './copy-document';
import { flDownloadSimpleIcon } from './download-simple';
import { flPrinterIcon } from './printer';
import { flCraftIcon } from './craft';
import { flCreateIcon } from './create';
import { flCreditCardIcon } from './credit-card';
import { flCurrencyEurIcon } from './currency-eur';
import { flDeleteCircleIcon } from './delete-circle';
import { flDesktopTowerIcon } from './desktop-tower';
import { flDisconnectedIcon } from './disconnected';
import { flDocumentCertificateIcon } from './document-certificate';
import { flDocumentIcon } from './document';
import { flDocumentsIcon } from './documents';
import { flDotsThreeIcon } from './dots-three';
import { flEnvelopeIcon } from './envelope';
import { flEyeIcon } from './eye';
import { flFeedbackIcon } from './feedback';
import { flFileDocIcon } from './file-doc';
import { flFilePdfIcon } from './file-pdf';
import { flFilePlusIcon } from './file-plus';
import { flFileUnknownIcon } from './file-unknown';
import { flFileIcon } from './file';
import { flFilterIcon } from './filter';
import { flFlagIcon } from './flag';
import { flFolderIcon } from './folder';
import { flForkKnifeIcon } from './fork-knife';
import { flGearIcon } from './gear';
import { flGlobeSimpleIcon } from './globe-simple';
import { flGrillIcon } from './grill';
import { flGroupsIcon } from './groups';
import { flHelpChatIcon } from './help-chat';
import { flHomeIcon } from './home';
import { flHotelCheckInIcon } from './hotel-check-in';
import { flHotelCheckOutIcon } from './hotel-check-out';
import { flHouseLineIcon } from './house-line';
import { flHouseIcon } from './house';
import { flImageIcon } from './image';
import { flImagesIcon } from './images';
import { flInfoSmallIcon } from './info-small';
import { flInfoSquareIcon } from './info-square';
import { flInfoIcon } from './info';
import { flKeyIcon } from './key';
import { flLaptopIcon } from './laptop';
import { flLaundryIcon } from './laundry';
import { flLightBulpIcon } from './light-bulp';
import { flLikeIcon } from './like';
import { flLink45DegIcon } from './link-45deg';
import { flLinkIcon } from './link';
import { flListOlIcon } from './list-ol';
import { flListUlIcon } from './list-ul';
import { flListIcon } from './list';
import { flLockIcon } from './lock';
import { flMailboxIcon } from './mailbox';
import { flMainMenuMoreIcon } from './main-menu-more';
import { flMapPinLineIcon } from './map-pin-line';
import { flMapPinIcon } from './map-pin';
import { flMeasureIcon } from './measure';
import { flMicrophoneIcon } from './microphone';
import { flMoneyIcon } from './money';
import { flMusicRoomIcon } from './music-room';
import { flNewsIcon } from './news';
import { flNotePencilIcon } from './note-pencil';
import { flPaperIcon } from './paper';
import { flPaperclipIcon } from './paperclip';
import { flParkingIcon } from './parking';
import { flPencilLineIcon } from './pencil-line';
import { flPhoneRingingIcon } from './phone-ringing';
import { flPhoneIcon } from './phone';
import { flPizzaOvenIcon } from './pizza-oven';
import { flPlanIcon } from './plan';
import { flPlusDarkCircleIcon } from './plus-dark-circle';
import { flPlusThickIcon } from './plus-thick';
import { flPlusIcon } from './plus';
import { flProfileIcon } from './profile';
import { flProhibitIcon } from './prohibit';
import { flPushPinIcon } from './push-pin';
import { flPuzzlePieceIcon } from './puzzle-piece';
import { flQuestionIcon } from './question';
import { flReceiptIcon } from './receipt';
import { flReceptionBellIcon } from './reception-bell';
import { flRepairIcon } from './repair';
import { flRoomIcon } from './room';
import { flSaunaIcon } from './sauna';
import { flSelectCaretDownIcon } from './select-caret-down';
import { flServicesIcon } from './services';
import { flShareNetworkIcon } from './share-network';
import { flShareIcon } from './share';
import { flShieldCheckIcon } from './shield-check';
import { flShoppingCartSimpleIcon } from './shopping-cart-simple';
import { flShoppingCartPlus } from './shopping-cart-plus';
import { flSignOutIcon } from './sign-out';
import { flSmileyIcon } from './smiley';
import { flSuitcaseSimpleIcon } from './suitcase-simple';
import { flToolBoxIcon } from './tool-box';
import { flTrashIcon } from './trash';
import { flTypeBoldIcon } from './type-bold';
import { flTypeH1Icon } from './type-h1';
import { flTypeH2Icon } from './type-h2';
import { flTypeH3Icon } from './type-h3';
import { flTypeItalicIcon } from './type-italic';
import { flUserAddIcon } from './user-add';
import { flUserCircleMinusIcon } from './user-circle-minus';
import { flUserStickerCircleIcon } from './user-sticker-circle';
import { flUserIcon } from './user';
import { flUsersIcon } from './users';
import { flVideoIcon } from './video';
import { flWalletIcon } from './wallet';
import { flWarningIcon } from './warning';
import { flWebIcon } from './web';
import { flWifiAntennaIcon } from './wifi-antenna';
import { flWifiHighIcon } from './wifi-high';
import { flXCircleIcon } from './x-circle';

export const flinkIcons = [fl3UserIcon, flTransferVerticalSquareIcon, flChannelIcon, flAddChannelIcon, flAllScopeIcon, flArrowLeftIcon, flArrowRightIcon, flArrowUpRightIcon, flArrowsClockwiseIcon, flArticleIcon, flBedIcon, flBellIcon, flBicycleIcon, flBookOpenIcon, flBubblePlusIcon, flBuildingIcon, flBuildingsIcon, flCalendarBlankIcon, flCalendarPlusIcon, flCalendarSmallIcon, flCalendarXIcon, flCalendarIcon, flCameraIcon, flCarIcon, flCaretDownIcon, flChartBarHorizontalIcon, flChartBarSquareIcon, flChatBubbleFavoriteOvalStarIcon, flChatBubbleOvalCheckIcon, flChatBubbleOvalDeleteIcon, flChatBubbleTextSquareIcon, flChatSendIcon, flChatIcon, flCheckSquareIcon, flCheckIcon, flChevronBackIcon, flChevronDownIcon, flChevronForwardIcon, flChevronUpIcon, flCircleMarkIcon, flCleaningIcon, flClockAfternoonIcon, flClockCounterClockwiseIcon, flCloseIcon, flCogIcon, flConferenceIcon, flConsumptionIcon, flCookieIcon, flCopyDocumentIcon, flDownloadSimpleIcon, flPrinterIcon, flCraftIcon, flCreateIcon, flCreditCardIcon, flCurrencyEurIcon, flDeleteCircleIcon, flDesktopTowerIcon, flDisconnectedIcon, flDocumentCertificateIcon, flDocumentIcon, flDocumentsIcon, flDotsThreeIcon, flEnvelopeIcon, flEyeIcon, flFeedbackIcon, flFileDocIcon, flFilePdfIcon, flFilePlusIcon, flFileUnknownIcon, flFileIcon, flFilterIcon, flFlagIcon, flFolderIcon, flForkKnifeIcon, flGearIcon, flGlobeSimpleIcon, flGrillIcon, flGroupsIcon, flHelpChatIcon, flHomeIcon, flHotelCheckInIcon, flHotelCheckOutIcon, flHouseLineIcon, flHouseIcon, flImageIcon, flImagesIcon, flInfoSmallIcon, flInfoSquareIcon, flInfoIcon, flKeyIcon, flLaptopIcon, flLaundryIcon, flLightBulpIcon, flLikeIcon, flLink45DegIcon, flLinkIcon, flListOlIcon, flListUlIcon, flListIcon, flLockIcon, flMailboxIcon, flMainMenuMoreIcon, flMapPinLineIcon, flMapPinIcon, flMeasureIcon, flMicrophoneIcon, flMoneyIcon, flMusicRoomIcon, flNewsIcon, flNotePencilIcon, flPaperIcon, flPaperclipIcon, flParkingIcon, flPencilLineIcon, flPhoneRingingIcon, flPhoneIcon, flPizzaOvenIcon, flPlanIcon, flPlusDarkCircleIcon, flPlusThickIcon, flPlusIcon, flProfileIcon, flProhibitIcon, flPushPinIcon, flPuzzlePieceIcon, flQuestionIcon, flReceiptIcon, flReceptionBellIcon, flRepairIcon, flRoomIcon, flSaunaIcon, flSelectCaretDownIcon, flServicesIcon, flShareNetworkIcon, flShareIcon, flShieldCheckIcon, flShoppingCartPlus, flShoppingCartSimpleIcon, flSignOutIcon, flSmileyIcon, flSuitcaseSimpleIcon, flToolBoxIcon, flTrashIcon, flTypeBoldIcon, flTypeH1Icon, flTypeH2Icon, flTypeH3Icon, flTypeItalicIcon, flUserAddIcon, flUserCircleMinusIcon, flUserStickerCircleIcon, flUserIcon, flUsersIcon, flVideoIcon, flWalletIcon, flWarningIcon, flWebIcon, flWifiAntennaIcon, flWifiHighIcon, flXCircleIcon];
